import async from '~/utils/async';

export default async(() => {
  const error = new Error('There is no match for the given route');

  error.status = 404;

  return Promise.reject(error);
})(() => null);
